import * as React from 'react';
import {IconButton} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import "./General.css";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import GridViewIcon from "@mui/icons-material/GridView";
import ConstructionIcon from "@mui/icons-material/Construction";
import PostAddIcon from '@mui/icons-material/PostAdd';
import BadgeIcon from '@mui/icons-material/Badge';

const MobileMenuButton =()=>{



const [anchorEl, setAnchorEl] = React.useState(null);
const open = Boolean(anchorEl);
const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
};
const handleClose = () => {
    setAnchorEl(null);
};
return(
    <div>
    <view>
        <IconButton

            id="demo-positioned-button"
            style={{
                borderColor: "#0000FF",
                backgroundColor: "##0000FF",
            }}
            onClick={handleClick}
        >
            <MenuIcon style={{ color: "#000000" }} />
        </IconButton>{" "}
    </view>

    <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"

        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
            vertical: "top",
            horizontal: "left",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "left",
        }}
    >
        <MenuItem>
            <Button href={'/'} style={{color:'#111111', fontFamily: 'Poppins', textTransform: 'none',}} startIcon={<GridViewIcon style={{ color: '#EC8D2B' }} />}>
                Dashboard
            </Button>
        </MenuItem>
        <MenuItem>
            <Button style={{color:'#111111', fontFamily: 'Poppins', textTransform: 'none',}} href={'/ClientList'} startIcon={<PersonOutlineIcon style={{ color: '#EC8D2B' }} />}>
                Clients
            </Button>
        </MenuItem>
        <MenuItem>
            <Button style={{color:'#111111', fontFamily: 'Poppins', textTransform: 'none',}} href={'/ServiceRequestList'} startIcon={<ConstructionIcon style={{ color: '#EC8D2B' }} />}>
            Service Requests
            </Button>
        </MenuItem>
        <MenuItem>
            <Button style={{color:'#111111', fontFamily: 'Poppins', textTransform: 'none',}} href={'/StaffMemberListView'} startIcon={<PostAddIcon style={{ color: '#EC8D2B' }} />}>
                Staff Member
            </Button>
        </MenuItem>
        <MenuItem>
            <Button style={{color:'#111111', fontFamily: 'Poppins', textTransform: 'none',}} href={'/ConsultantList'} startIcon={<BadgeIcon style={{ color: '#EC8D2B' }} />}>
                Internal Consultant
            </Button>
        </MenuItem>
    </Menu>

    </div>)
}
export default MobileMenuButton;
